import { render, staticRenderFns } from "./subwayrunner.vue?vue&type=template&id=6b4a9fbe&scoped=true"
import script from "./subwayrunner.vue?vue&type=script&lang=js"
export * from "./subwayrunner.vue?vue&type=script&lang=js"
import style0 from "./subwayrunner.vue?vue&type=style&index=0&id=6b4a9fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a9fbe",
  null
  
)

export default component.exports